module.exports = __webpack_public_path__ + "img/zk-icon-material.9e68820f.svg";